import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/shop/styles/index.css';
import { addSitePassword, captureAffiliateId } from '@link/share/utils';
import { initGDPRCookieBanner, initRecaptcha } from '@link/share/vendors';
import '@link/shop/i18n';
import '@link/shop/vendors/gtm';
import App from '@link/shop/App';

// Capture the affiliate tag from the entry URL first: anything below can
// replace the document or navigate, and the tag is read from session storage
// from here on.
captureAffiliateId();

// Enable password verification for 'testing' environment before React renders
const env = import.meta.env.VITE_APP_SHOP_ENV as string;
const requirePassword = ['testing'].includes(env);
addSitePassword(requirePassword);

initRecaptcha(import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY);

// Show the Silktide Cookie Banner to GDPR-country visitors before React renders
initGDPRCookieBanner();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
